// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViBRJAqFex7OSYBUjnmZ{display:inline-block;color:var(--color-515-granat);text-align:center;font-size:12px;font-style:normal;font-weight:700;line-height:116.5%;padding:17px;border:1px solid var(--color-515-zimnyszary);border-radius:20px}.ViBRJAqFex7OSYBUjnmZ .EkAa4OAcNdEwWQk0gj0s>*{margin:2px 2px 13px}.ViBRJAqFex7OSYBUjnmZ.cqCkARApIn2A9BXhUqKU .EkAa4OAcNdEwWQk0gj0s{color:#c8d9e0}.ViBRJAqFex7OSYBUjnmZ.cqCkARApIn2A9BXhUqKU .EkAa4OAcNdEwWQk0gj0s .BloM_FN9vgqOR2tcd2U0{color:#05a595}.ViBRJAqFex7OSYBUjnmZ.HRvx7db9GeL4COnruPSg .EkAa4OAcNdEwWQk0gj0s{color:#824d2f}.ViBRJAqFex7OSYBUjnmZ.HRvx7db9GeL4COnruPSg .EkAa4OAcNdEwWQk0gj0s .BloM_FN9vgqOR2tcd2U0{color:#4bcaff}.ViBRJAqFex7OSYBUjnmZ.jGDLrORWyXJgYbp6u6K5 .EkAa4OAcNdEwWQk0gj0s{color:#333}.ViBRJAqFex7OSYBUjnmZ.jGDLrORWyXJgYbp6u6K5 .EkAa4OAcNdEwWQk0gj0s .BloM_FN9vgqOR2tcd2U0{color:#4bcaff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `ViBRJAqFex7OSYBUjnmZ`,
	"diagram": `EkAa4OAcNdEwWQk0gj0s`,
	"moth": `cqCkARApIn2A9BXhUqKU`,
	"active": `BloM_FN9vgqOR2tcd2U0`,
	"pill": `HRvx7db9GeL4COnruPSg`,
	"drop": `jGDLrORWyXJgYbp6u6K5`
};
export default ___CSS_LOADER_EXPORT___;
